import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import debounce from "lodash.debounce";
import { toast } from "react-toastify";
import { LogOutIcon } from "lucide-react"; // Ví dụ: dùng icon từ lucide-react

import logo from "../../assets/logo.png";
import Login from "../Login/Login";
import Register from "../Register/Register";
import MobileNavbar from "../MobileNavbar/MobileNavbar";

import {
  FaUser,
  FaHeart,
  FaHistory,
  FaUserCircle,
  FaSignOutAlt,
  FaTimes,
  FaCaretRight,
  FaCaretDown,
} from "react-icons/fa";
import { PiBellRinging } from "react-icons/pi";
import BASE_URL from "../../configs/api";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const [showDropdown, setShowDropdown] = useState(false);

  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const [showMenu, setShowMenu] = useState(false);

  const [openQuocGia, setOpenQuocGia] = useState(false);

  const [openTheloai, setOpenTheloai] = useState(false);

  const [theloais, setTheloais] = useState([]);

  const [quocgias, setQuocgias] = useState([]);

  const [keyword, setKeyword] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  const inputRef = useRef(null);
  const bellRef = useRef(null);

  const navigate = useNavigate();

  const fetchSuggestions = useCallback(
    debounce(async (q) => {
      if (q.length < 3) {
        setSuggestions([]);
        setShowSuggestions(false);
        setLoadingSuggestions(false);
        return;
      }

      try {
        const response = await axios.get(
          `${BASE_URL}/api/search-goi-y/?q=${q}`
        );
        setSuggestions(response.data.results);
        setShowSuggestions(true);
      } catch (error) {
      } finally {
        setTimeout(() => setLoadingSuggestions(false), 300);
      }
    }, 300),
    []
  );

  useEffect(() => {
    if (keyword.length >= 3) {
      setLoadingSuggestions(true);
      fetchSuggestions(keyword);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
      setLoadingSuggestions(false);
    }
  }, [keyword, fetchSuggestions]);

  useEffect(() => {
    return () => {
      fetchSuggestions.cancel();
    };
  }, [fetchSuggestions]);

  useEffect(() => {
    const fetchTheloais = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/theloai/`);
        setTheloais(response.data.results);
      } catch (error) {}
    };
    const fetchThongbaos = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/api/thongbao/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setNotifications(response.data.slice(0, 4));
      } catch (error) {}
    };

    const fetchQuocgias = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/quocgia/`);
        setQuocgias(response.data);
      } catch (error) {}
    };

    fetchTheloais();
    fetchQuocgias();
    fetchThongbaos();

    const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
    const storedUserInfo = localStorage.getItem("userInfo");

    if (storedIsLoggedIn && storedUserInfo) {
      setIsLoggedIn(true);
      setUserInfo(JSON.parse(storedUserInfo));
    }

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    function handleClickOutside(event) {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setShowNotifications(false);
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectSuggestion = (movie) => {
    setKeyword("");
    setSuggestions([]);
    setShowSuggestions(false);
    navigate(`/phim/${movie.slug}`);
    closeMenu();
  };

  // Xử lý tìm kiếm khi nhấn Enter
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      if (keyword.trim().length >= 3) {
        setSuggestions([]);
        setShowSuggestions(false);
        navigate(`/search?q=${encodeURIComponent(keyword.trim())}`);
        setKeyword("");
        closeMenu();
        inputRef.current?.blur();
      } else {
        toast.info("Vui lòng nhập ít nhất 3 ký tự để tìm kiếm");
      }
    }
  };

  const openRegister = () => {
    setShowLogin(false);
    closeMenu();
    setShowRegister(true);
  };
  const openLogin = () => {
    setShowRegister(false);
    closeMenu();
    setShowLogin(true);
  };

  const closeMenu = () => {
    setShowMenu(false);
    setOpenQuocGia(false);
    setOpenTheloai(false);
  };
  const openMenu = () => {
    setShowMenu(true);
  };
  const toggleMenu = () => setShowMenu((prev) => !prev);
  const toggleDropdown = () => setShowDropdown((prev) => !prev);
  const toggleQuocGia = () => {
    setOpenQuocGia((prev) => !prev);
  };
  const toggleTheloai = () => {
    setOpenTheloai((prev) => !prev);
  };

  const handleMobileLinkClick = () => {
    closeMenu();
  };
  const handleMobileLoginClick = () => {
    closeMenu();
    setShowLogin(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserInfo(null);
    closeMenu();
    setShowDropdown(false);
    setOpenQuocGia(false);
    setOpenTheloai(false);
    setShowLogin(false);
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("accessToken");
    navigate("/");
  };
  return (
    <div>
      <header
        className={`transition-all duration-300 z-50 ${
          scrolled
            ? "fixed top-0 left-0 right-0 bg-[#0d0f17]"
            : "relative bg-transparent"
        }`}
        role="banner"
      >
        <nav
          className="xl:container xl:mx-auto px-4 h-14 sm:h-15 xl:h-20 flex items-center justify-between"
          role="navigation"
          aria-label="Điều hướng chính"
        >
          <div className="flex items-center space-x-6 lg:space-x-8 flex-shrink-0">
            <Link
              to="/"
              className="text-yellow-100 text-xl lg:text-4xl md:text-2xl sm:text-xl font-bold tracking-wider"
              aria-label="Trang chủ MePhim - Xem phim online miễn phí"
              title="MePhim - Xem phim online chất lượng cao"
            >
              <img
                className="h-6 lg:h-8 object-cover"
                src={logo}
                alt="MePhim - Website xem phim online miễn phí chất lượng cao"
                width="auto"
                height="32"
              />
            </Link>

            <div className="relative hidden xl:flex">
              <label htmlFor="search-input" className="sr-only">
                Tìm kiếm phim
              </label>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill="currentColor"
                    d="M10 18a7.95 7.95 0 0 0 4.897-1.688l4.396 4.396l1.414-1.414l-4.396-4.396A7.95 7.95 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8s3.589 8 8 8m0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6s-6-2.691-6-6s2.691-6 6-6"
                  />
                  <path
                    fill="currentColor"
                    d="M11.412 8.586c.379.38.588.882.588 1.414h2a3.98 3.98 0 0 0-1.174-2.828c-1.514-1.512-4.139-1.512-5.652 0l1.412 1.416c.76-.758 2.07-.756 2.826-.002"
                  />
                </svg>
              </span>
              <input
                id="search-input"
                type="search"
                ref={inputRef}
                placeholder="Tìm kiếm phim theo tên, thể loại, diễn viên..."
                className="pl-10 w-[300px] bg-[#ffffff1f] text-white placeholder-white rounded-md py-2.5 focus:outline-none focus:ring-1 focus:ring-white text-sm transition duration-150 ease-in-out"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={handleSearch}
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 250)}
                aria-describedby="search-description"
                autoComplete="off"
              />
              <div id="search-description" className="sr-only">
                Nhập tên phim, thể loại hoặc diễn viên để tìm kiếm
              </div>

              <ul
                className={`absolute z-50 top-full mt-3 w-full bg-black/60 backdrop-blur-xl rounded-md shadow-2xl border border-white/10 max-h-[40rem] overflow-hidden text-white transform origin-top transition-all duration-300 ease-out ${
                  showSuggestions && suggestions.length > 0
                    ? "opacity-100 scale-y-100 translate-y-0 pointer-events-auto"
                    : "opacity-0 scale-y-95 -translate-y-2 pointer-events-none"
                }`}
                role="listbox"
                aria-label="Gợi ý tìm kiếm"
              >
                {loadingSuggestions ? (
                  <div className="flex flex-col items-center justify-center py-8 px-4">
                    <div className="relative">
                      <div className="w-12 h-12 rounded-full border-4 border-orange-500/30 border-t-orange-500 animate-spin mb-4"></div>
                      <div className="absolute inset-0 w-12 h-12 rounded-full border-4 border-transparent border-r-amber-500/50 animate-spin animation-delay-150"></div>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-medium text-white mb-1">
                        Đang tìm kiếm...
                      </p>
                      <p className="text-xs text-gray-400">
                        Vui lòng chờ trong giây lát
                      </p>
                    </div>
                    <span className="sr-only">
                      Đang tải danh sách gợi ý phim
                    </span>
                  </div>
                ) : (
                  <>
                    {/* Header */}
                    <div className="px-5 py-4 bg-gradient-to-r from-orange-500/20 to-amber-500/20 border-b border-white/10">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-gradient-to-br from-orange-500 to-amber-500 rounded-lg flex items-center justify-center mr-3">
                            <svg
                              className="w-4 h-4 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                              />
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-sm font-semibold text-white">
                              Kết quả tìm kiếm
                            </h3>
                            <p className="text-xs text-gray-400">
                              Chọn phim để xem chi tiết
                            </p>
                          </div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full">
                          <span className="text-xs font-medium text-white/90">
                            {suggestions.length}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Scrollable Content */}
                    <div className="overflow-y-auto max-h-[32rem] scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent">
                      <ul className="py-2">
                        {suggestions.map((movie, index) => (
                          <li
                            key={movie.id}
                            className="group relative flex items-center px-5 py-4 cursor-pointer hover:bg-gradient-to-r hover:from-orange-500/10 hover:to-amber-500/10 transition-all duration-200 border-l-4 border-transparent hover:border-orange-500"
                            onClick={() => handleSelectSuggestion(movie)}
                            role="option"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                handleSelectSuggestion(movie);
                              }
                            }}
                          >
                            {/* Movie Poster */}
                            <div className="relative flex-shrink-0 mr-4">
                              <div className="w-16 h-22 rounded-sm overflow-hidden shadow-lg ring-2 ring-white/10 group-hover:ring-orange-500/50 transition-all duration-300">
                                <img
                                  src={
                                    movie.poster_url ||
                                    "https://via.placeholder.com/150"
                                  }
                                  alt={`Poster phim ${movie.ten_phim}`}
                                  className="w-full h-full object-fill transition-transform duration-300 group-hover:scale-110"
                                  loading="lazy"
                                />
                              </div>

                              {/* Quality/Status Badge */}
                              {movie.chat_luong && (
                                <div className="absolute -top-1 -right-1 bg-gradient-to-r from-orange-500 to-amber-500 text-black text-[9px] font-bold px-1.5 py-0.5 rounded-full shadow-lg">
                                  {movie.chat_luong}
                                </div>
                              )}
                            </div>

                            {/* Movie Info */}
                            <div className="flex-2 min-w-0 space-y-2">
                              <div className="flex items-start justify-between">
                                <h4 className="text-sm font-bold text-white group-hover:text-orange-300 transition-colors duration-200 line-clamp-2 pr-2 leading-tight">
                                  {movie.ten_phim}
                                </h4>
                                {movie.rate && (
                                  <div className="flex items-center space-x-1 flex-shrink-0 bg-yellow-500/20 px-2 py-1 rounded-full">
                                    <svg
                                      className="w-3 h-3 text-yellow-400"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                    </svg>
                                    <span className="text-xs text-yellow-400 font-medium">
                                      {movie.rate}
                                    </span>
                                  </div>
                                )}
                              </div>

                              {movie.ten_khac && (
                                <p className="text-xs italic text-gray-300 group-hover:text-gray-200 transition-colors duration-200 line-clamp-1">
                                  {movie.ten_khac}
                                </p>
                              )}

                              <div className="flex items-center justify-between">
                                {movie.tinh_trang && (
                                  <span className="inline-flex items-center text-xs font-medium">
                                    {movie.tinh_trang}
                                  </span>
                                )}

                                {/* Additional info */}
                                <div className="flex items-center space-x-2 text-xs text-gray-400">
                                  {movie.nam_phat_hanh && (
                                    <span className="flex items-center">
                                      <svg
                                        className="w-3 h-3 mr-1"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                        />
                                      </svg>
                                      {movie.nam_phat_hanh}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Arrow Icon */}
                            <div className="flex-shrink-0 ml-3 opacity-0 group-hover:opacity-100 transition-all duration-200 transform group-hover:translate-x-1">
                              <svg
                                className="w-5 h-5 text-orange-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M9 5l7 7-7 7"
                                />
                              </svg>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* View All Results Footer */}
                    <div className="border-t border-white/10 bg-gradient-to-r from-[#1f2233]/80 to-[#191b28]/80">
                      <li
                        className="group flex items-center justify-center py-4 text-sm font-semibold text-orange-400 hover:text-orange-300 cursor-pointer transition-all duration-200 hover:bg-gradient-to-r hover:from-orange-500/10 hover:to-amber-500/10"
                        onClick={() => handleSearch({ key: "Enter" })}
                        role="option"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handleSearch({ key: "Enter" });
                          }
                        }}
                      >
                        <div className="flex items-center space-x-2">
                          <svg
                            className="w-4 h-4 transform group-hover:scale-110 transition-transform duration-200"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                          <span>Xem toàn bộ kết quả</span>
                          <svg
                            className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                          </svg>
                        </div>
                      </li>
                    </div>
                  </>
                )}
              </ul>
            </div>

            <nav
              className="hidden lg:flex items-center space-x-3"
              role="navigation"
              aria-label="Danh mục phim"
            >
              <Link
                to={`/phim/loaiphim/phimle`}
                onClick={handleMobileLinkClick}
                className="text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 ease-in-out"
                title="Xem phim lẻ mới nhất"
              >
                Phim Lẻ
              </Link>

              <Link
                to={`/phim/loaiphim/phimbo`}
                onClick={handleMobileLinkClick}
                className="text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 ease-in-out"
                title="Xem phim bộ hay nhất"
              >
                Phim Bộ
              </Link>

              <Link
                to={`/phim/loaiphim/hoathinh`}
                onClick={handleMobileLinkClick}
                className="text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 ease-in-out"
                title="Xem phim hoạt hình anime"
              >
                Hoạt Hình
              </Link>

              <div className="relative">
                <button
                  onClick={toggleQuocGia}
                  className="flex justify-between items-center text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition-colors"
                  aria-expanded={openQuocGia}
                  aria-haspopup="true"
                  aria-label="Chọn phim theo quốc gia"
                  title="Phim theo quốc gia"
                >
                  Quốc gia
                  <span className="ml-2" aria-hidden="true">
                    {openQuocGia ? <FaCaretDown /> : <FaCaretRight />}
                  </span>
                </button>

                <div
                  className={`grid grid-cols-3 gap-x-5 gap-y-5 bg-black shadow-lg rounded-[5px] px-7 overflow-hidden absolute left-0 w-[400px] mt-2
      transform transition-transform duration-300 ease-in-out origin-top
      ${
        openQuocGia
          ? "scale-y-100 opacity-100 py-8 max-h-[500px] z-10"
          : "scale-y-0 opacity-0 py-0 max-h-0"
      }
    `}
                  role="menu"
                  aria-label="Danh sách quốc gia"
                >
                  {quocgias.map((quocgia) => (
                    <Link
                      key={quocgia.code}
                      to={`/quoc-gia/${quocgia.code}/${quocgia.name}`}
                      onClick={handleMobileLinkClick}
                      className="text-gray-300 hover:text-yellow-400 text-[0.8rem] transition font-semibold"
                      role="menuitem"
                      title={`Xem phim ${quocgia.name}`}
                    >
                      {quocgia.name}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="relative">
                <button
                  onClick={toggleTheloai}
                  className="flex justify-between items-center text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 ease-in-out w-full"
                  aria-expanded={openTheloai}
                  aria-haspopup="true"
                  aria-label="Chọn phim theo thể loại"
                  title="Phim theo thể loại"
                >
                  Thể loại
                  <span className="ml-2" aria-hidden="true">
                    {openTheloai ? <FaCaretDown /> : <FaCaretRight />}
                  </span>
                </button>

                <div
                  className={`grid grid-cols-3 gap-x-5 gap-y-5 bg-black shadow-lg rounded-[5px] px-7 overflow-hidden absolute left-0 w-[430px] mt-2
      transform duration-300 ease-in-out origin-top
      ${
        openTheloai
          ? "scale-y-100 opacity-100 py-8 max-h-[500px] z-10"
          : "scale-y-0 opacity-0 py-0 max-h-0"
      }
    `}
                  role="menu"
                  aria-label="Danh sách thể loại"
                >
                  {theloais.map((theloai) => (
                    <Link
                      key={theloai.slug}
                      to={`/the-loai/${theloai.slug}/${encodeURIComponent(
                        theloai.ten
                      )}`}
                      onClick={handleMobileLinkClick}
                      className="text-gray-300 hover:text-yellow-400 text-[0.8rem] transition font-semibold"
                      role="menuitem"
                      title={`Xem phim ${theloai.ten}`}
                    >
                      {theloai.ten}
                    </Link>
                  ))}
                </div>
              </div>
            </nav>
          </div>

          <div className="flex items-center space-x-4 lg:space-x-4">
            <button
              className="hidden 2xl:flex items-center text-white text-xs font-medium py-1 space-x-3 rounded-md transition duration-150 ease-in-out"
              aria-label="Tải ứng dụng MePhim"
              title="Tải ứng dụng MePhim cho điện thoại"
            >
              <svg
                id="Pc"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-10 h-10"
                aria-hidden="true"
              >
                <defs>
                  <linearGradient
                    id="pcGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#ff6b35" />
                    <stop offset="50%" stopColor="#f7931e" />
                    <stop offset="100%" stopColor="#ff4081" />
                  </linearGradient>
                </defs>

                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.9998 16.8992C11.1655 16.8992 11.2998 16.7649 11.2998 16.5992V11.5982C11.2998 9.28322 13.1838 7.39922 15.4998 7.39922H18.7998C18.9238 7.39922 19.0446 7.41106 19.1616 7.43327C19.3745 7.47368 19.5998 7.32682 19.5998 7.11012V6.69922C19.5998 6.67022 19.5968 6.64022 19.5918 6.61222C19.2488 4.66722 17.4468 3.19922 15.4008 3.19922H6.79982C4.42882 3.19922 2.49982 5.12822 2.49982 7.49922V12.5982C2.49982 14.9692 4.42882 16.8992 6.79982 16.8992H8.24282L7.86182 19.2492H5.85982C5.44582 19.2492 5.10982 19.5852 5.10982 19.9992C5.10982 20.4132 5.44582 20.7492 5.85982 20.7492H10.7598C11.1738 20.7492 11.5098 20.4132 11.5098 19.9992C11.5098 19.5852 11.1738 19.2492 10.7598 19.2492H9.38082L9.76182 16.8992H10.9998Z"
                  fill="url(#pcGradient)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.1912 18.4564C16.7712 18.4564 16.4302 18.1154 16.4302 17.6954C16.4302 17.2754 16.7712 16.9344 17.1912 16.9344C17.6112 16.9344 17.9522 17.2754 17.9522 17.6954C17.9522 18.1154 17.6112 18.4564 17.1912 18.4564ZM18.8002 8.90039H15.5002C14.0362 8.90039 12.8002 10.1364 12.8002 11.5994V18.0994C12.8002 19.5884 14.0112 20.7994 15.5002 20.7994H18.8002C20.2892 20.7994 21.5002 19.5884 21.5002 18.0994V11.5994C21.5002 10.1364 20.2642 8.90039 18.8002 8.90039Z"
                  fill="#ffffff"
                />
              </svg>

              <div className="flex flex-col items-start space-y-1">
                <p className="text-[12px]">Tải ứng dụng</p>
                <p className="font-extrabold text-[14px] text-white">MePhim</p>
              </div>
            </button>

            <div
              className="hidden 2xl:block h-10 md:h-8 lg:h-10 w-px bg-white opacity-40"
              aria-hidden="true"
            ></div>

            {!isLoggedIn ? (
              <button
                onClick={() => {
                  setShowLogin(true);
                  setOpenQuocGia(false);
                  setOpenTheloai(false);
                }}
                className="hidden xl:flex bg-white hover:bg-neutral-200 text-black text-xs font-semibold px-6 py-3 rounded-3xl transition duration-150 ease-in-out whitespace-nowrap"
                aria-label="Đăng nhập tài khoản"
                title="Đăng nhập để lưu phim yêu thích"
              >
                <FaUser
                  className="mr-2 w-4 h-4 flex items-center"
                  aria-hidden="true"
                />
                <span className="text-[14px]">Đăng nhập</span>
              </button>
            ) : (
              <div className="hidden xl:flex relative gap-4">
                <div className="flex flex-col items-center space-y-1">
                  <div
                    className="relative p-2 border-[2px] border-white rounded-full cursor-pointer"
                    onClick={() => {
                      setShowNotifications(!showNotifications);
                      setShowDropdown(false);
                    }}
                    role="button"
                    aria-label={`Thông báo (${notifications.length} tin mới)`}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setShowNotifications(!showNotifications);
                        setShowDropdown(false);
                      }
                    }}
                  >
                    <PiBellRinging size={20} aria-hidden="true" />
                    {notifications.length > 0 && (
                      <span
                        className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full"
                        aria-label={`${notifications.length} thông báo mới`}
                      >
                        {notifications.length}
                      </span>
                    )}

                    {showNotifications && (
                      <div
                        className="absolute top-12 right-0 w-96 z-50 bg-neutral-800 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 text-gray-200 flex flex-col"
                        role="dialog"
                        aria-label="Danh sách thông báo"
                      >
                        <div className="p-4 flex justify-between items-center border-b border-gray-700 text-sm">
                          <span className="font-semibold text-white">
                            Phim ({notifications.length})
                          </span>
                          <button
                            className="text-xs text-white hover:text-yellow-300 flex items-center transition"
                            aria-label="Đánh dấu tất cả đã đọc"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 mr-1"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                              aria-hidden="true"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Đã đọc
                          </button>
                        </div>

                        <ul className="text-sm px-3 overflow-y-auto max-h-[400px] space-y-3 py-3">
                          {notifications.length === 0 ? (
                            <li className="text-white px-4 py-2 italic text-center">
                              Thêm phim vào danh sách yêu thích để nhận được
                              thông báo
                            </li>
                          ) : (
                            notifications.map((item) => (
                              <li
                                key={item.id}
                                onClick={() =>
                                  navigate(
                                    `/phim/${
                                      item.phim
                                    }?ten_phim=${encodeURIComponent(
                                      item.ten_phim
                                    )}`,
                                    { state: { ten_phim: item.ten_phim } }
                                  )
                                }
                                className="flex items-start gap-3 cursor-pointer hover:bg-white/10 p-2 rounded-lg transition"
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    navigate(
                                      `/phim/${
                                        item.phim
                                      }?ten_phim=${encodeURIComponent(
                                        item.ten_phim
                                      )}`,
                                      { state: { ten_phim: item.ten_phim } }
                                    );
                                  }
                                }}
                              >
                                <img
                                  src={item.poster}
                                  alt={`Poster phim ${item.ten_phim}`}
                                  className="w-12 h-[70px] object-fill rounded-sm"
                                  loading="lazy"
                                  width="48"
                                  height="70"
                                />
                                <div className="flex flex-col gap-1">
                                  <div className="flex items-center gap-2">
                                    <div className="text-white font-medium break-words">
                                      <span className="text-sm transition">
                                        {item.ten_phim}{" "}
                                        <strong className="text-gray-400">
                                          vừa cập nhật
                                        </strong>
                                      </span>{" "}
                                      <span className="text-sm text-white font-medium transition">
                                        {item.noidung}
                                      </span>
                                    </div>
                                  </div>
                                  <time className="text-xs text-yellow-400 italic">
                                    {item.date}
                                  </time>
                                </div>
                              </li>
                            ))
                          )}
                        </ul>
                        <div className="p-2 border-t border-gray-700 text-center">
                          <button className="text-sm font-medium text-white hover:text-yellow-300 transition w-full py-1">
                            Xem toàn bộ
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <button
                    className="flex items-center justify-center border-white border-[2px] rounded-full"
                    onClick={toggleDropdown}
                    aria-label={`Menu tài khoản ${userInfo?.username || ""}`}
                    aria-expanded={showDropdown}
                    aria-haspopup="true"
                  >
                    <img
                      src={userInfo.avatar_gg || userInfo.avatar}
                      alt={`Avatar của ${userInfo?.username || "người dùng"}`}
                      className="w-9 h-9 rounded-full"
                      onClick={() => {
                        setShowNotifications(false);
                      }}
                      width="36"
                      height="36"
                      loading="lazy"
                    />
                  </button>
                  {showDropdown && userInfo && (
                    <div
                      className="absolute right-0 top-[3.2rem] w-64 bg-[#191b28] rounded-sm  shadow-2xl ring-1 ring-white/10 backdrop-blur-lg z-50 overflow-hidden"
                      role="menu"
                      aria-label="Menu tài khoản"
                    >
                      {/* Header with user info */}
                      <div className="px-5 py-4 bg-gradient-to-r from-orange-500/20 to-amber-500/20 border-b border-neutral-700/50">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-sm">
                              {userInfo.username.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div>
                            <p className="text-white font-semibold text-sm truncate">
                              Chào, {userInfo.username}
                            </p>
                            <p className="text-gray-400 text-xs">
                              Thành viên VIP
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Menu Items */}
                      <div className="py-2">
                        <Link
                          to="/user/favorites"
                          className="group flex items-center px-5 py-3 hover:bg-gradient-to-r hover:from-orange-500/10 hover:to-amber-500/10 transition-all duration-200 border-l-4 border-transparent hover:border-orange-500"
                          onClick={() => setShowDropdown(false)}
                          role="menuitem"
                          title="Danh sách phim yêu thích"
                        >
                          <div className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center mr-3 group-hover:bg-red-500/30 transition-colors">
                            <FaHeart
                              className="text-red-400 text-sm"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="flex-1">
                            <span className="text-gray-200 group-hover:text-white transition-colors font-medium">
                              Yêu thích
                            </span>
                            <p className="text-xs text-gray-500 group-hover:text-gray-400">
                              Phim đã lưu
                            </p>
                          </div>
                        </Link>

                        <Link
                          to="/user/continue-watching"
                          className="group flex items-center px-5 py-3 hover:bg-gradient-to-r hover:from-orange-500/10 hover:to-amber-500/10 transition-all duration-200 border-l-4 border-transparent hover:border-orange-500"
                          onClick={() => setShowDropdown(false)}
                          role="menuitem"
                          title="Lịch sử xem phim"
                        >
                          <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center mr-3 group-hover:bg-blue-500/30 transition-colors">
                            <FaHistory
                              className="text-blue-400 text-sm"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="flex-1">
                            <span className="text-gray-200 group-hover:text-white transition-colors font-medium">
                              Xem tiếp
                            </span>
                            <p className="text-xs text-gray-500 group-hover:text-gray-400">
                              Lịch sử xem
                            </p>
                          </div>
                        </Link>

                        <Link
                          to="/user/profile"
                          className="group flex items-center px-5 py-3 hover:bg-gradient-to-r hover:from-orange-500/10 hover:to-amber-500/10 transition-all duration-200 border-l-4 border-transparent hover:border-orange-500"
                          onClick={() => setShowDropdown(false)}
                          role="menuitem"
                          title="Thông tin tài khoản"
                        >
                          <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center mr-3 group-hover:bg-green-500/30 transition-colors">
                            <FaUserCircle
                              className="text-green-400 text-sm"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="flex-1">
                            <span className="text-gray-200 group-hover:text-white transition-colors font-medium">
                              Tài khoản
                            </span>
                            <p className="text-xs text-gray-500 group-hover:text-gray-400">
                              Thông tin cá nhân
                            </p>
                          </div>
                        </Link>
                      </div>

                      {/* Divider */}
                      <div className="border-t border-neutral-700/50 my-1"></div>

                      {/* Logout Button */}
                      <div className="py-2">
                        <button
                          onClick={handleLogout}
                          className="group w-full flex items-center px-5 py-3 hover:bg-red-500/10 transition-all duration-200 border-l-4 border-transparent hover:border-red-500"
                          role="menuitem"
                          title="Đăng xuất tài khoản"
                        >
                          <div className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center mr-3 group-hover:bg-red-500/30 transition-colors">
                            <FaSignOutAlt
                              className="text-red-400 text-sm"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="flex-1 text-left">
                            <span className="text-red-400 group-hover:text-red-300 transition-colors font-medium">
                              Đăng xuất
                            </span>
                            <p className="text-xs text-gray-500 group-hover:text-gray-400">
                              Thoát tài khoản
                            </p>
                          </div>
                        </button>
                      </div>

                      {/* Decorative bottom border */}
                      <div className="h-1 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-500"></div>
                    </div>
                  )}
                </div>
              </div>
            )}

            <button
              className="xl:hidden text-gray-300 hover:text-white focus:outline-none"
              onClick={showMenu ? closeMenu : toggleMenu}
              aria-label={showMenu ? "Đóng menu" : "Mở menu"}
              aria-expanded={showMenu}
              aria-controls="mobile-menu"
            >
              {showMenu ? (
                <FaTimes className="h-6 w-6" aria-hidden="true" />
              ) : (
                <svg
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                </svg>
              )}
            </button>
          </div>
        </nav>
      </header>

      {showMenu && (
        <div
          className="fixed inset-0 bg-black/70 z-40 sm:hidden"
          onClick={closeMenu}
          aria-hidden="true"
        ></div>
      )}

      <div
        className={`fixed top-0 left-0 bottom-0 z-50 w-72 max-w-[85%] bg-[#191b24] backdrop-blur-sm shadow-2xl transform ${
          showMenu ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out 2xl:hidden flex flex-col`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-menu-title"
        aria-describedby="mobile-menu-description"
      >
        {/* Tiêu đề ẩn cho screen reader */}
        <h2 id="mobile-menu-title" className="sr-only">
          Menu điều hướng di động
        </h2>
        <p id="mobile-menu-description" className="sr-only">
          Truy cập các tính năng chính của ứng dụng xem phim MePhim
        </p>

        {/* Header với logo */}
        <header className="flex items-center justify-between p-4 border-b border-white/10 flex-shrink-0">
          <Link
            to="/"
            onClick={handleMobileLinkClick}
            className="flex-shrink-0"
            aria-label="Về trang chủ MePhim"
          >
            <img
              className="h-6 px-1 object-contain"
              src={logo}
              alt="Logo MePhim - Xem phim online miễn phí"
              width="auto"
              height="24"
            />
          </Link>
        </header>

        {/* Nội dung chính */}
        <main className="flex-grow overflow-y-auto p-5 space-y-6">
          {/* Phần đăng nhập/thông tin user */}
          <section className="space-y-3" aria-labelledby="user-section">
            <h3 id="user-section" className="sr-only">
              Thông tin tài khoản
            </h3>
            {!isLoggedIn ? (
              <button
                onClick={handleMobileLoginClick}
                className="w-full items-center justify-center flex bg-white hover:bg-neutral-200 text-black text-xs font-semibold px-6 py-3 rounded-3xl transition duration-150 ease-in-out whitespace-nowrap"
                aria-label="Đăng nhập vào tài khoản MePhim"
              >
                <FaUser
                  className="mr-2 w-4 h-4 flex items-center"
                  aria-hidden="true"
                />
                <span className="text-[14px]">Đăng nhập</span>
              </button>
            ) : (
              <div className="text-sm text-gray-200 space-y-2 rounded-lg p-3.5 border border-white/10 bg-white/5">
                <div className="flex items-center space-x-4 mb-3">
                  <img
                    src={userInfo.avatar_gg || userInfo.avatar}
                    alt={`Ảnh đại diện của ${
                      userInfo?.username || "người dùng"
                    }`}
                    className="w-12 h-12 rounded-full object-cover ring-1 ring-offset-1 ring-offset-transparent ring-white"
                    width="48"
                    height="48"
                  />
                  <div className="flex flex-col">
                    <span className="font-semibold text-base text-white truncate">
                      Chào, {userInfo?.username || "Bạn"}!
                    </span>
                    <Link
                      to="/user/profile"
                      className="text-xs text-orange-400 hover:underline"
                      onClick={handleMobileLinkClick}
                      aria-label="Xem và chỉnh sửa hồ sơ cá nhân"
                    >
                      Xem hồ sơ
                    </Link>
                  </div>
                </div>
                <nav aria-label="Menu tài khoản cá nhân">
                  <Link
                    to="/user/favorites"
                    className="flex items-center px-2 py-2 hover:bg-white/10 rounded-md"
                    onClick={handleMobileLinkClick}
                    aria-label="Xem danh sách phim yêu thích"
                  >
                    <FaHeart
                      className="mr-3 text-pink-400 w-4 flex-shrink-0"
                      aria-hidden="true"
                    />
                    <span className="text-gray-100">Yêu thích</span>
                  </Link>
                  <Link
                    to="/user/continue-watching"
                    className="flex items-center px-2 py-2.5 hover:bg-white/10 rounded-md"
                    onClick={handleMobileLinkClick}
                    aria-label="Xem lịch sử phim đã xem"
                  >
                    <FaHistory
                      className="mr-3 text-purple-400 w-4 flex-shrink-0"
                      aria-hidden="true"
                    />
                    <span className="text-gray-100">Lịch sử xem</span>
                  </Link>
                  {/* Footer với nút đăng xuất */}
                  {isLoggedIn && (
                    <Link
                      onClick={handleLogout}
                      className="flex items-center px-2 py-2.5 hover:bg-white/10 rounded-md"
                      aria-label="Đăng xuất tài khoản"
                    >
                      <LogOutIcon
                        className="mr-3 text-red-400 w-4 flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span className="text-gray-100">Đăng xuất</span>
                    </Link>
                  )}
                </nav>
              </div>
            )}
          </section>

          {/* Phần tìm kiếm */}
          <section className="relative" aria-labelledby="search-section">
            <h3 id="search-section" className="sr-only">
              Tìm kiếm phim
            </h3>
            <div className="relative">
              <label htmlFor="mobile-search" className="sr-only">
                Tìm kiếm phim theo tên
              </label>
              <span className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill="currentColor"
                    d="M10 18a7.95 7.95 0 0 0 4.897-1.688l4.396 4.396l1.414-1.414l-4.396-4.396A7.95 7.95 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8s3.589 8 8 8m0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6s-6-2.691-6-6s2.691-6 6-6"
                  />
                  <path
                    fill="currentColor"
                    d="M11.412 8.586c.379.38.588.882.588 1.414h2a3.98 3.98 0 0 0-1.174-2.828c-1.514-1.512-4.139-1.512-5.652 0l1.412 1.416c.76-.758 2.07-.756 2.826-.002"
                  />
                </svg>
              </span>
              <input
                id="mobile-search"
                type="search"
                placeholder="Tìm kiếm phim"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={handleSearch}
                className="w-full bg-white/5 border-white text-white placeholder-gray-400 rounded-lg py-2 pl-11 pr-4 focus:outline-none focus:ring-1 focus:ring-white focus:border-transparent text-sm"
                aria-describedby="search-instructions"
                autoComplete="off"
              />

              <p id="search-instructions" className="sr-only">
                Nhập tên phim và nhấn Enter để tìm kiếm. Gợi ý sẽ hiện ra khi
                bạn gõ.
              </p>
            </div>

            <ul
              id="search-suggestions"
              className={`absolute z-[100] top-full mt-3 w-full bg-gradient-to-br from-neutral-900/98 via-neutral-800/98 to-neutral-900/98 backdrop-blur-xl rounded-md shadow-2xl border border-white/10 max-h-[32rem] overflow-hidden text-white transform origin-top transition-all duration-300 ease-out ${
                showSuggestions && suggestions.length > 0
                  ? "opacity-100 scale-y-100 translate-y-0 pointer-events-auto"
                  : "opacity-0 scale-y-95 -translate-y-2 pointer-events-none"
              }`}
              role="listbox"
              aria-label="Gợi ý tìm kiếm phim"
            >
              {/* Header */}
              <div className="px-4 py-3 bg-orange-200 border-b border-white/10">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-white/90 flex items-center">
                    <svg
                      className="w-4 h-4 mr-2 text-orange-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                    Kết quả tìm kiếm
                  </span>
                  <span className="text-xs text-white/60 bg-white/10 px-2 py-1 rounded-full">
                    {suggestions.length} phim
                  </span>
                </div>
              </div>

              {/* Scrollable Content */}
              <div className="overflow-y-auto max-h-[28rem] scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent">
                {suggestions.map((phim, index) => (
                  <li
                    key={phim.id}
                    className="group relative flex items-center px-4 py-3 cursor-pointer border-b border-white/5 last:border-b-0 hover:bg-gradient-to-r hover:from-orange-500/10 hover:to-amber-500/10 transition-all duration-200 hover:scale-[1.02] hover:shadow-lg"
                    onClick={() => handleSelectSuggestion(phim)}
                    role="option"
                    aria-selected="false"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectSuggestion(phim);
                      }
                    }}
                  >
                    {/* Hover indicator */}
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-orange-500 to-amber-500 transform scale-y-0 group-hover:scale-y-100 transition-transform duration-200 origin-center rounded-r-full"></div>

                    {/* Movie Poster */}
                    <div className="relative flex-shrink-0 mr-4">
                      <div className="w-12 h-16 rounded-lg overflow-hidden shadow-lg ring-1 ring-white/10 group-hover:ring-orange-500/50 transition-all duration-200">
                        <img
                          src={
                            phim.poster_url || "https://via.placeholder.com/150"
                          }
                          alt={`Poster phim ${phim.ten_phim}`}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                          width="48"
                          height="64"
                          loading="lazy"
                        />
                      </div>
                      {/* Quality badge */}
                      {phim.chat_luong && (
                        <div className="absolute -top-1 -right-1 bg-gradient-to-r from-orange-500 to-amber-500 text-black text-[8px] font-bold px-1.5 py-0.5 rounded-md shadow-lg">
                          {phim.chat_luong}
                        </div>
                      )}
                    </div>

                    {/* Movie Info */}
                    <div className="flex-1 min-w-0 space-y-1">
                      <div className="flex items-start justify-between">
                        <h4 className="text-sm font-semibold text-white group-hover:text-orange-300 transition-colors duration-200 line-clamp-1 pr-2">
                          {phim.ten_phim}
                        </h4>
                      </div>

                      {phim.ten_khac && (
                        <p className="text-xs text-white/60 group-hover:text-white/80 transition-colors duration-200 line-clamp-1">
                          {phim.ten_khac}
                        </p>
                      )}

                      {/* Additional info */}
                    </div>

                    {/* Arrow icon */}
                    <div className="flex-shrink-0 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <svg
                        className="w-4 h-4 text-orange-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </div>
                  </li>
                ))}
              </div>

              {/* Footer */}
              <div className="px-4 py-2 bg-gradient-to-r from-neutral-800/50 to-neutral-700/50 border-t border-white/5">
                <p className="text-xs text-white/60 text-center flex items-center justify-center">
                  <svg
                    className="w-3 h-3 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                  Nhấn Enter để chọn phim
                </p>
              </div>
            </ul>
          </section>

          {/* Navigation chính */}
          <nav
            className="flex flex-col space-y-1 border-t border-white/10 pt-3"
            aria-labelledby="main-nav"
          >
            <h3
              id="main-nav"
              className="px-3 pb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
            >
              Khám phá
            </h3>

            <Link
              to={`/phim/loaiphim/phimle`}
              onClick={handleMobileLinkClick}
              className="text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 ease-in-out"
              aria-label="Xem danh sách phim lẻ"
            >
              Phim Lẻ
            </Link>

            <Link
              to={`/phim/loaiphim/phimbo`}
              onClick={handleMobileLinkClick}
              className="text-white hover:text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 ease-in-out"
              aria-label="Xem danh sách phim bộ"
            >
              Phim Bộ
            </Link>

            {/* Dropdown Quốc gia */}
            <div>
              <button
                onClick={toggleQuocGia}
                className="flex items-center justify-between w-full px-3 py-2 rounded-md text-sm font-medium text-white hover:bg-white/10 hover:text-white transition-colors"
                aria-expanded={openQuocGia}
                aria-controls="countries-list"
                aria-label="Xem phim theo quốc gia"
              >
                Quốc gia
                <span className="ml-2" aria-hidden="true">
                  {openQuocGia ? <FaCaretDown /> : <FaCaretRight />}
                </span>
              </button>
              <div
                id="countries-list"
                className={`grid grid-cols-3 gap-x-3 gap-y-3 bg-gradient-to-r from-black/15 to-black/15 shadow-lg rounded-[5px] px-6 overflow-hidden transition-all duration-300 ${
                  openQuocGia
                    ? "max-h-96 py-3 opacity-100"
                    : "max-h-0 py-0 opacity-0"
                }`}
                role="region"
                aria-labelledby="countries-heading"
              >
                <h4 id="countries-heading" className="sr-only">
                  Danh sách quốc gia
                </h4>
                {quocgias.map((quocgia) => (
                  <Link
                    key={quocgia.code}
                    to={`/quoc-gia/${quocgia.code}/${quocgia.name}`}
                    onClick={handleMobileLinkClick}
                    className="text-gray-300 hover:text-yellow-400 text-[10px] transition"
                    aria-label={`Xem phim ${quocgia.name}`}
                  >
                    {quocgia.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Dropdown Thể loại */}
            <div>
              <button
                onClick={toggleTheloai}
                className="flex items-center justify-between w-full px-3 py-2 rounded-md text-sm font-medium text-white hover:bg-white/10 hover:text-white transition-colors"
                aria-expanded={openTheloai}
                aria-controls="genres-list"
                aria-label="Xem phim theo thể loại"
              >
                Thể loại
                <span className="ml-2" aria-hidden="true">
                  {openTheloai ? <FaCaretDown /> : <FaCaretRight />}
                </span>
              </button>
              <div
                id="genres-list"
                className={`grid grid-cols-2 gap-x-8 gap-y-3 bg-gradient-to-r from-black/15 to-black/15 shadow-lg rounded-[5px] px-6 overflow-hidden transition-all duration-300 ${
                  openTheloai
                    ? "max-h-96 py-3 opacity-100"
                    : "max-h-0 py-0 opacity-0"
                }`}
                role="region"
                aria-labelledby="genres-heading"
              >
                <h4 id="genres-heading" className="sr-only">
                  Danh sách thể loại phim
                </h4>
                {theloais.map((theloai) => (
                  <Link
                    key={theloai.slug}
                    to={`/the-loai/${theloai.slug}/${encodeURIComponent(
                      theloai.ten
                    )}`}
                    onClick={handleMobileLinkClick}
                    className="text-gray-300 hover:text-yellow-400 text-[10px] transition"
                    aria-label={`Xem phim thể loại ${theloai.ten}`}
                  >
                    {theloai.ten}
                  </Link>
                ))}
              </div>
            </div>

            <Link
              to="/lich-chieu"
              onClick={handleMobileLinkClick}
              className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-white hover:bg-white/10 hover:text-white transition-colors"
              aria-label="Xem lịch chiếu và thông báo mới"
            >
              Thông báo
            </Link>
          </nav>

          {/* Phần tải app */}
          <section
            className="border-t border-white/10 pt-5 space-y-3"
            aria-labelledby="app-download"
          >
            <h3 id="app-download" className="sr-only">
              Tải ứng dụng di động
            </h3>
            <button
              className="w-full flex items-center text-white text-xs font-medium px-3 py-1 space-x-3 rounded-md bg-gradient-to-r from-white/5 to-white/5 shadow-lg"
              aria-label="Tải ứng dụng MePhim cho điện thoại"
            >
              <svg
                id="Pc"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-10 h-10"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.9998 16.8992C11.1655 16.8992 11.2998 16.7649 11.2998 16.5992V11.5982C11.2998 9.28322 13.1838 7.39922 15.4998 7.39922H18.7998C18.9238 7.39922 19.0446 7.41106 19.1616 7.43327C19.3745 7.47368 19.5998 7.32682 19.5998 7.11012V6.69922C19.5998 6.67022 19.5968 6.64022 19.5918 6.61222C19.2488 4.66722 17.4468 3.19922 15.4008 3.19922H6.79982C4.42882 3.19922 2.49982 5.12822 2.49982 7.49922V12.5982C2.49982 14.9692 4.42882 16.8992 6.79982 16.8992H8.24282L7.86182 19.2492H5.85982C5.44582 19.2492 5.10982 19.5852 5.10982 19.9992C5.10982 20.4132 5.44582 20.7492 5.85982 20.7492H10.7598C11.1738 20.7492 11.5098 20.4132 11.5098 19.9992C11.5098 19.5852 11.1738 19.2492 10.7598 19.2492H9.38082L9.76182 16.8992H10.9998Z"
                  fill="currentColor"
                  color="#FF6F40 "
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.1912 18.4564C16.7712 18.4564 16.4302 18.1154 16.4302 17.6954C16.4302 17.2754 16.7712 16.9344 17.1912 16.9344C17.6112 16.9344 17.9522 17.2754 17.9522 17.6954C17.9522 18.1154 17.6112 18.4564 17.1912 18.4564ZM18.8002 8.90039H15.5002C14.0362 8.90039 12.8002 10.1364 12.8002 11.5994V18.0994C12.8002 19.5884 14.0112 20.7994 15.5002 20.7994H18.8002C20.2892 20.7994 21.5002 19.5884 21.5002 18.0994V11.5994C21.5002 10.1364 20.2642 8.90039 18.8002 8.90039Z"
                  fill="#ffffff"
                />
              </svg>
              <div className="flex flex-col items-start space-y-1">
                <p className="text-[12px]">Tải ứng dụng</p>
                <p className="font-extrabold text-[14px] text-white">MePhim</p>
              </div>
            </button>
          </section>
        </main>
      </div>
      <MobileNavbar
        openMenu={openMenu}
        openLogin={openLogin}
        closeMenu={closeMenu}
        isLoggedIn={true}
      />

      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        setUserInfo={setUserInfo}
        setIsLoggedIn={setIsLoggedIn}
        onSwitchToRegister={openRegister}
      />
      <Register
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        onSwitchToLogin={openLogin}
      />
    </div>
  );
}

export default Header;
